/** Category API returns either a flat array or `{ categories: [...] }`. */
export function asCategoryList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.categories)) return data.categories;
  return [];
}
